import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderItemModel } from '@ov-suite/models-order';
import { FormBuilder, Validators } from '@angular/forms';
import _ from 'lodash';

interface NewLineProduct {
  productId: number;
  quantity: number;
  note: string;
}

@Component({
  selector: 'ov-suite-add-new-line',
  templateUrl: './add-new-line.component.html',
  styleUrls: ['./add-new-line.component.css']
})
export class AddNewLineComponent implements OnInit {
  @Input() selectedOrderItem: OrderItemModel;

  @Output() newLineItemOutput: EventEmitter<OrderItemModel> = new EventEmitter<OrderItemModel>();

  productSkuName: string;

  form = this.formBuilder.group({
    productId: [],
    note: [''],
    quantity: [1, [Validators.required, Validators.min(1)]]
  });

  constructor(private readonly formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.productSkuName = this.selectedOrderItem.productSku.name;

    this.form.patchValue({
      productId: this.selectedOrderItem.productSkuId,
      note: '',
      quantity: 1
    });

    this.form.valueChanges.subscribe(changes => {
      if (this.form.valid) {
        const newLineItem = this.prepareNewLineItem(changes);
        this.newLineItemOutput.emit(newLineItem);
      }
    });
  }

  prepareNewLineItem(item: NewLineProduct) {
    const clone = _.cloneDeep(this.selectedOrderItem);

    // Create a new item (no ID)
    delete clone.id;

    clone.quantity = item.quantity;
    clone.note = item.note;
    clone.split = true; // Mark as split item, just like in split functionality

    return clone;
  }
}
